<template>
	<div
		class="input-component"
		:class="{ 'not-icon': !wantIcon }"
	>
		<div
			class="label label-with-infoicon-containter"
			v-if="label"
		>
			<span>{{ label === '_' ? '\u00A0' : label }}</span>
			<InfoIcon
				v-if="infoIconObj"
				:infoIconObj="infoIconObj"
			/>
		</div>
		<div
			class="skeleton"
			:class="{
				match: valuesMatch,
				'no-match': valuesDontMatch,
				action: util.hasKey($slots, 'action'),
			}"
		>
			<div
				class="saturn"
				:class="{ invalid: invalid }"
				@click="toggleShowError(null, $event)"
				@mouseover="toggleShowError(true, $event)"
				@mouseleave="toggleShowError(false, $event)"
			>
				<div
					class="saturn-textbox"
					:class="cssClass"
				>
					<input
						:type="'type' in $props ? type : 'text'"
						v-model="maskedValue"
						:placeholder="placeholder"
						:readonly="readonly"
						:disabled="disabled"
						@input="handleOnChange"
						@click="handleOnClick"
						@blur="handleOnBlur"
						:maxlength="17"
						:pattern="pattern"
						ref="inputHandle"
						:autofocus="autofocus ? autofocus : false"
						@keyup.enter="enterHandler"
					/>
					<div
						class="saturn-textbox-error-message"
						v-if="errorHover && invalid"
					>
						<div v-if="util.hasKey($slots, 'validation')">
							<slot name="validation"></slot>
						</div>
						<div v-else>Invalid Input</div>
					</div>
				</div>

				<div
					v-if="util.hasKey($slots, 'action')"
					class="action-slot"
				>
					<slot name="action"></slot>
				</div>
				<div
					v-else-if="!util.hasKey($slots, 'action') && wantIcon"
					class="saturn-icon"
				>
					<i :class="iconStyle"></i>
				</div>
			</div>
			<div
				class="cdk"
				v-if="util.hasKey($props, 'cdk')"
				v-show="vstore.showCDK"
			>
				<div class="cdk-textbox">
					<input
						type="text"
						v-model="vm.cdk"
						class="cdk-textbox"
						readonly
					/>
				</div>
				<div class="cdk-icon">
					<div
						class="cdk-off"
						v-if="!valuesMatch"
					>
						<span
							class="cdk-paste"
							@click="copyValueFromCDK()"
							title="Update Saturn value with CDK value"
							><i class="fas fa-paste"></i
						></span>
						<span title="Values don't match"><i class="fas fa-exclamation-circle"></i></span>
					</div>
					<div>CDK</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import InfoIcon from '@core/components/InfoIcon.vue';
	import util from '@core/services/util';
	import vstore from '@core/services/vstore';

	export default {
		name: 'InputMasked',
		props: [
			'saturn',
			'cdk',
			'label',
			'placeholder',
			'invalid',
			'readonly',
			'disabled',
			'multiline',
			'cssClass',
			'copy',
			'comparer',
			'get',
			'set',
			'maxlength',
			'minlength',
			'type',
			'pattern',
			'showIcon',
			'icon',
			'mask',
			'infoIconObj',
			'autofocus',
		],
		directives: {
			focus: {
				inserted(el) {
					el.focus();
				},
			},
		},
		emits: ['keyEnter', 'click', 'blur', 'focus', 'clear', 'update:saturn', 'change', 'input'],
		data() {
			return {
				vstore: vstore.state,
				vm: {
					saturn: null,
					cdk: null,
				},
				errorHover: false,
				wantIcon: null,
				iconStyle: null,
				maskedValue: null,
			};
		},
		computed: {
			util() {
				return util;
			},
			valuesMatch() {
				if (this.comparer) return util.hasKey(this.$props, 'cdk') && this.comparer(this.vm.saturn, this.vm.cdk);
				else return util.hasKey(this.$props, 'cdk') && this.isNull(this.vm.saturn) === this.isNull(this.vm.cdk);
			},
			valuesDontMatch() {
				if (this.comparer) return util.hasKey(this.$props, 'cdk') && !this.comparer(this.vm.saturn, this.vm.cdk);
				else return util.hasKey(this.$props, 'cdk') && this.isNull(this.vm.saturn) !== this.isNull(this.vm.cdk);
			},
			hasValidationSlot() {
				return !!this.$slots['validation'];
			},
		},
		mounted() {
			if (this.autofocus) {
				this.$refs.inputHandle.focus();
			}
		},
		created() {
			this.init();
			this.wantIcon = typeof this.showIcon != 'undefined' ? this.showIcon : true;
			this.iconStyle = !util.isNull(this.icon) ? this.icon : 'fas fa-phone';

			this.$watch(
				() => this.$props,
				function (newValue) {
					this.init();
				},
				{ deep: true, immediate: true },
			);

			if (!this.get) {
				this.$watch(
					() => this.vm.saturn,
					function (newValue) {
						this.$emit('update:saturn', this.vm.saturn);
						this.$emit('change');
					},
					{ deep: true },
				);
			}
		},
		methods: {
			init() {
				this.vm.saturn = this.set ? this.set(this.saturn) : this.saturn;
				this.vm.cdk = this.cdk;
				this.maskedValue = this.maskValue(this.vm.saturn);
			},
			handleOnChange($e) {
				const inputValue = $e.target.value.toUpperCase();
				const realValue = this.unMaskValue(inputValue);

				this.vm.saturn = realValue;
				this.maskedValue = this.maskValue(realValue);
				this.$emit('input', realValue);
			},
			handleOnBlur($e) {
				this.handleOnChange($e);
				this.$emit('blur');
			},
			handleOnClick($e) {
				//this.handleOnChange($e);
				this.$emit('click');
			},
			isNull(val) {
				if (val === null) {
					return '';
				} else {
					return val;
				}
			},
			copyValueFromCDK() {
				if (this.copy) {
					this.vm.saturn = this.copy(this.vm.cdk);
				} else {
					this.vm.saturn = this.vm.cdk;
				}

				this.updateSaturnGetterVersion();
			},
			unMaskValue(value) {
				let output = '';

				if (!util.isNull(value) && value.length > 0) {
					for (let i = 0; i < value.length && i < this.mask.length; i++) {
						if (this.mask[i] === 'X' && value[i]) {
							output += value[i];
						} else if (this.mask[i] !== value[i]) {
							output += value[i];
						}
					}
				}

				return output;
			},

			maskValue(value) {
				if (!util.isNull(value)) {
					let output = '';
					let valIndex = 0;
					for (let i = 0; i < this.mask.length; i++) {
						if (valIndex < value.length) {
							if (this.mask[i] === 'X') {
								output += value[valIndex];
								valIndex++;
							} else {
								output += this.mask[i];
							}
						}
					}
					return output;
				}
			},
			toggleShowError(override, event) {
				const isMobile = window.matchMedia('(max-width: 600px)').matches;

				if (event.type === 'click') {
					this.errorHover = !this.errorHover;
				} else if (!isMobile) {
					this.errorHover = override;
				}
			},
			updateSaturnGetterVersion() {
				if (this.get) {
					this.$emit('update:saturn', this.get(this.vm.saturn));
					this.$emit('change');
				}
			},
			enterHandler() {
				this.$emit('keyEnter');
			},
		},
		components: {
			InfoIcon,
		},
	};

	/*
     * USAGE
     *

     <InputTextbox label="Customer" v-model:saturn="customer1.saturn" :cdk="customer1.cdk" :invalid="v$.customer1.saturn.$invalid" placeholder="Name">
        <template #validation>
            <div v-if="v$.customer1.saturn.required.$invalid">Customer is required</div>
        </template>
    </InputTextbox>

     <InputTextbox label="Customer" v-model:saturn="customer1.saturn" placeholder="Name" :invalid="v$.customer1.saturn.$invalid" readonly="true"></InputTextbox>
     <InputTextbox label="Customer" v-model:saturn="customer1.saturn" placeholder="Name" :invalid="v$.customer1.saturn.$invalid"></InputTextbox>
    */
</script>
